import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { withStyles, Divider, Typography } from '@material-ui/core';

class FHEDivider extends PureComponent {
    static propTypes = {
        theme: PropTypes.object.isRequired,
        classes: PropTypes.object.isRequired,
        title: PropTypes.string,
        IconComponent: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
        IconSize: PropTypes.number,
        color: PropTypes.string,
    };

    static defaultProps = {
        color: null,
        IconSize: 15,
        IconComponent: null,
        title: null,
    };

    render() {
        const { classes, theme, title, color, IconComponent, IconSize } = this.props;
        return (
            <div className={classes.dividerContainer}>
                {(title !== null || IconComponent !== null) && (
                    <Typography variant="caption">
                        {IconComponent !== null && <IconComponent color={color ? color : theme.palette.primary.main} size={IconSize} />}
                        {title !== null && <span className={classes.tableTitle}>{title}</span>}
                    </Typography>
                )}
                <Divider component="div" className={classes.divider} />
            </div>
        );
    }
}

const styles = theme => ({
    dividerContainer: {
        width: '100%',
        margin: '10px 0',
        color: props => (props.color ? props.color : theme.palette.primary.main),
    },
    divider: {
        backgroundColor: props => (props.color ? props.color : theme.palette.primary.main),
    },
    tableTitle: {
        marginLeft: 5,
    },
});
export default withStyles(styles, { withTheme: true })(FHEDivider);



// WEBPACK FOOTER //
// ./data/components/FHEDivider.js